import { useState } from "react";
import { ChevronLeft, ChevronRight, RotateCw, Shuffle } from "lucide-react";
import { SubjectBadge } from "@/components/SubjectBadge";

export const Flashcards = ({ terms, onShuffle }) => {
  const [i, setI] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const t = terms[Math.min(i, terms.length - 1)];
  const go = (d) => { setFlipped(false); setI((p) => (p + d + terms.length) % terms.length); };

  return (
    <div className="mx-auto max-w-2xl" data-testid="flashcards">
      <p className="mb-3 text-center text-sm font-extrabold" data-testid="flashcard-counter">Carta {i + 1} di {terms.length}</p>
      <button onClick={() => setFlipped((f) => !f)} data-testid="flashcard" className="block w-full [perspective:1200px]">
        <div className={`relative h-72 w-full transition-transform duration-500 [transform-style:preserve-3d] ${flipped ? "[transform:rotateY(180deg)]" : ""}`}>
          <div className="ink-box absolute inset-0 flex flex-col items-center justify-center rounded-3xl bg-white p-8 [backface-visibility:hidden]">
            <SubjectBadge subject={t.subject} />
            <p className="font-display mt-4 text-4xl font-bold sm:text-5xl" data-testid="flashcard-front">{t.word}</p>
            <p className="mt-6 flex items-center gap-2 text-sm font-bold text-neutral-500"><RotateCw className="h-4 w-4" /> Tocca per girare</p>
          </div>
          <div className="ink-box absolute inset-0 flex flex-col justify-center overflow-y-auto rounded-3xl bg-[var(--sun)] p-8 text-left [backface-visibility:hidden] [transform:rotateY(180deg)]">
            <p className="text-lg font-bold leading-relaxed" data-testid="flashcard-back">{t.definition}</p>
            {t.examples[0] && <p className="mt-4 text-sm italic">«{t.examples[0]}»</p>}
          </div>
        </div>
      </button>
      <div className="mt-6 flex items-center justify-center gap-3">
        <button onClick={() => go(-1)} data-testid="flashcard-prev" className="ink-box-sm ink-press rounded-full bg-white p-3"><ChevronLeft className="h-5 w-5" /></button>
        <button onClick={() => { onShuffle(); setI(0); setFlipped(false); }} data-testid="flashcard-shuffle" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-white px-4 py-3 text-sm font-extrabold"><Shuffle className="h-4 w-4" /> Mescola</button>
        <button onClick={() => go(1)} data-testid="flashcard-next" className="ink-box-sm ink-press rounded-full bg-white p-3"><ChevronRight className="h-5 w-5" /></button>
      </div>
    </div>
  );
};
